import { render, staticRenderFns } from "./OrdersCurrentByWh.vue?vue&type=template&id=462f83a6&"
import script from "./OrdersCurrentByWh.vue?vue&type=script&lang=js&"
export * from "./OrdersCurrentByWh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports